import { getConfig } from '@tcs/create-account/utils/configService';
import css from 'styled-jsx/css';

export const getStyles = async () => {
  const config = await getConfig();
  const basePath = config.REACT_APP_BASE_PATH;

  return css.global`
    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 700;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 700;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Bold-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 500;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 500;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Medium-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 400;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 400;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Regular-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 300;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 300;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Light-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: normal;
      font-weight: 200;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin.ttf')
          format('truetype');
      font-display: swap;
    }

    @font-face {
      font-family: 'GT Walsheim';
      font-style: oblique;
      font-weight: 200;
      src: url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.woff2')
          format('woff2'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.woff')
          format('woff'),
        url('${basePath}/fonts/gt-walsheim/GT-Walsheim-Pro-Thin-Oblique.ttf')
          format('truetype');
      font-display: swap;
    }

    html {
      text-rendering: optimizeLegibility;
      -moz-osx-font-smoothing: grayscale;
      -webkit-font-smoothing: antialiased;
    }

    body {
      min-width: 320px;
      margin: 0;
      font-family: 'GT Walsheim', sans-serif;
      font-weight: 200;
      color: #212529;
      font-size: 16px;
      line-height: 1.5;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    ul,
    ol {
      margin: 0;
    }
  `;
};
